import { MessageCircle } from "lucide-react";

export default function FloatingWhatsApp() {
  return (
    <a
      href="https://wa.me/31615460576?text=Hoi%2C%20ik%20wil%20graag%20info%20over%20een%20toiletrenovatie."
      target="_blank"
      rel="noreferrer"
      aria-label="WhatsApp De Toiletman"
      className="fixed bottom-5 right-5 z-50 inline-flex items-center justify-center w-14 h-14 rounded-full bg-[#25D366] text-white shadow-2xl hover:scale-105 active:scale-95 transition-transform pulse-ring"
      data-testid="floating-whatsapp-btn"
    >
      <MessageCircle className="w-7 h-7" strokeWidth={2.2} />
    </a>
  );
}
